import { render } from "./AnalyticsNew.vue?vue&type=template&id=7c7d59f9"
import script from "./AnalyticsNew.vue?vue&type=script&lang=js"
export * from "./AnalyticsNew.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__